// src/data/faq.js
//
// FONTE ÚNICA DE VERDADE DO FAQ.
//
// Este arquivo alimenta três lugares ao mesmo tempo:
//   1. o bloco visível na página inicial (FaqSection.js)
//   2. a página estática public/faq.html
//   3. o JSON-LD FAQPage dentro de public/index.html
//
// Os itens 2 e 3 são GERADOS por scripts/gerar-faq.js, que roda
// automaticamente antes de todo `npm run build`. Nunca edite faq.html
// nem o bloco de JSON-LD à mão — edite aqui.
//
// REGRA: só entra afirmação verificável no produto. Preço, prazo e
// regra de ordenação precisam bater com o que o código faz. Uma
// resposta errada aqui vira citação errada no ChatGPT e no Google.

const FAQ = [
  {
    p: 'Anunciar imóvel no UMARKT é gratuito?',
    r: 'Sim. Publicar anúncio no UMARKT é gratuito e sem limite de quantidade. Não existe período de teste nem mensalidade para manter o anúncio no ar, e o UMARKT não cobra comissão sobre a venda ou o aluguel.'
  },
  {
    p: 'O que é pago no UMARKT?',
    r: 'Apenas o impulsionamento, que é opcional. São três planos: Impulsionar Básico por R$ 29,99 (7 dias), Impulsionar Pro por R$ 59,99 (15 dias) e Impulsionar Premium por R$ 99,99 (30 dias). Quem não impulsiona mantém o anúncio publicado normalmente, sem prazo de expiração.'
  },
  {
    p: 'Como o UMARKT ordena os imóveis nos resultados?',
    r: 'A listagem é ordenada primeiro pela pontuação de impulsionamento e depois pela data de publicação, do mais recente para o mais antigo. Anúncios impulsionados aparecem à frente; entre anúncios não impulsionados, o mais recente vem primeiro.'
  },
  {
    p: 'O UMARKT cobra comissão sobre a venda ou o aluguel?',
    r: 'Não. O UMARKT conecta quem anuncia e quem procura, não participa da negociação e não cobra percentual sobre o valor do imóvel.'
  },
  {
    p: 'Quem pode anunciar no UMARKT?',
    r: 'Proprietários que querem vender ou alugar por conta própria, corretores autônomos e imobiliárias. As três categorias usam a mesma plataforma e a mesma publicação gratuita.'
  },
  {
    p: 'Preciso de CRECI para anunciar um imóvel?',
    r: 'Não para anunciar um imóvel próprio. O registro no CRECI é exigido apenas para criar um perfil de corretor dentro da plataforma.'
  },
  {
    p: 'Em quais cidades o UMARKT funciona?',
    r: 'O UMARKT é focado em Chapecó e nas cidades do Oeste de Santa Catarina. A plataforma aceita imóveis de qualquer parte do Brasil, mas o público e a curadoria são concentrados nessa região.'
  },
  {
    p: 'Quanto tempo leva para o anúncio aparecer no site?',
    r: 'Todo anúncio novo entra com status de aguardando aprovação e é publicado depois de passar pela revisão da equipe. A revisão existe para impedir anúncio duplicado, incompleto ou fora da região de atuação.'
  },
  {
    p: 'Consigo falar direto com o dono do imóvel?',
    r: 'Sim. O telefone de contato de quem publicou fica visível no anúncio, seja proprietário, corretor ou imobiliária. O UMARKT não intermedia a conversa nem exige que ela passe pela plataforma.'
  },
  {
    p: 'Minha imobiliária pode enviar todos os imóveis de uma vez?',
    r: 'Sim, por integração XML. Cada conta de imobiliária recebe um token de importação e o UMARKT lê o arquivo XML do sistema que a imobiliária já usa, criando e atualizando os anúncios automaticamente.'
  },
  {
    p: 'Qual a diferença entre o UMARKT e o ZAP Imóveis ou o VivaReal?',
    r: 'Nos portais nacionais não existe plano gratuito: para o imóvel aparecer é preciso contratar um pacote. No UMARKT a publicação é gratuita e ilimitada, e o impulsionamento é uma escolha, não uma condição. O UMARKT também é focado em Chapecó e no Oeste de Santa Catarina, uma região pouco coberta pelos portais nacionais.'
  },
  {
    p: 'Como entro em contato com o UMARKT?',
    r: 'Pelo e-mail contato@umarkt.com.br.'
  }
]

module.exports = FAQ
